import React from 'react'
import { truncateText } from '../../helpers/utils';
import { get } from 'lodash';
import { vehicleTypes } from '../../consts/vehicleTypes';
import ReactCountryFlag from 'react-country-flag';
import BrowseCell from '../Table/ButtonsCell/BrowseCell/BrowseCell';
import ScoreCell from '../Table/ScoreCell/ScoreCell';


const SingleRow = (isMobile, vehicleType) => ((item) => {
    const formattedModel = truncateText(get(item, ['vehicle', 'model']), 17, 'right');
    const highestBetValue = get(item, 'highest_bet');

    const mobileCells =
      { [vehicleTypes.Motorbike]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, 'brand')} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, ['vehicle', 'total_mileage'])}</span>
          </div>
        </td>
      ],
      [vehicleTypes.AgriculturalMachine]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, 'brand')} {get(item, ['vehicle', 'category'])}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'production_year'])}, {get(item, ['vehicle', 'meter'])}</span>
          </div>
        </td>
      ],
      [vehicleTypes.Camper]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle', 'body_mark'])} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, ['vehicle', 'total_mileage'])}</span>
          </div>
        </td>
      ], };
    const desktopCells =
      { [vehicleTypes.Motorbike]: [
          <td key="brand">{get(item, 'brand')}</td>,
          <td key="model" className="cell-model">
            {formattedModel}
          </td>,
          <td key="year">{get(item, ['vehicle', 'year'])}</td>,
          <td key="total_mileage">{get(item, ['vehicle', 'total_mileage'])}</td>,
          <td key="zip_code" style={{ position: 'relative', }}>
            {get(item, 'country_code') &&
              <ReactCountryFlag
                countryCode={get(item, 'country_code')}
                svg
                style={{
                  position: 'absolute',
                  top: '2em',
                  width: '2.7em',
                  height: '1.4 em',
                  opacity: '78%',
                }}
              />}
            <div style={{ whiteSpace: 'nowrap', }}>{get(item, 'zip_code')}</div>

          </td>,
          <td key="browse_cell" className="cell-owners">
            <BrowseCell
              hihestBetValue={highestBetValue}
              buyNowContract={get(item, 'buy_now_contract')}
              contractSent={get(item, 'contract_sent')}
            />
          </td>
      ],
      [vehicleTypes.AgriculturalMachine]: [
        <td key="brand">{get(item, 'brand')}</td>,
        <td key="category" className="cell-model">
          {get(item, ['vehicle', 'category'])}
        </td>,
        <td key="year">{get(item, ['vehicle', 'production_year'])}</td>,
        <td key="meter">{get(item, ['vehicle', 'meter'])}</td>,
        <td key="zip_code" style={{ position: 'relative', }}>
          {get(item, 'country_code') &&
            <ReactCountryFlag
              countryCode={get(item, 'country_code')}
              svg
              style={{
                position: 'absolute',
                top: '2em',
                width: '2.7em',
                height: '1.4 em',
                opacity: '78%',
              }}
            />}
          <div style={{ whiteSpace: 'nowrap', }}>{get(item, 'zip_code')}</div>

        </td>,
        <td key="browse_cell" className="cell-owners">
          <BrowseCell
            hihestBetValue={highestBetValue}
            buyNowContract={get(item, 'buy_now_contract')}
            contractSent={get(item, 'contract_sent')}
          />
        </td>
    ], [vehicleTypes.Camper]: [
        <td key="brand">{get(item, ['vehicle', 'body_mark'])}</td>,
        <td key="model">{get(item, ['vehicle', 'model'])}</td>,
        <td key="year">{get(item, ['vehicle', 'year'])}</td>,
        <td key="meter">{get(item, ['vehicle', 'total_mileage'])}</td>,
        <td key="zip_code" style={{ position: 'relative', }}>
          {get(item, 'country_code') &&
            <ReactCountryFlag
              countryCode={get(item, 'country_code')}
              svg
              style={{
                position: 'absolute',
                top: '2em',
                width: '2.7em',
                height: '1.4 em',
                opacity: '78%',
              }}
            />}
          <div style={{ whiteSpace: 'nowrap', }}>{get(item, 'zip_code')}</div>

        </td>,
        <td key="browse_cell" className="cell-owners">
          <BrowseCell
            hihestBetValue={highestBetValue}
            buyNowContract={get(item, 'buy_now_contract')}
            contractSent={get(item, 'contract_sent')}
          />
        </td>

    ], };

    return [
      <ScoreCell
        key="score"
        score={get(item, ['vehicle', 'score'])}
        photo={get(item, 'photo')}
        model={get(item, ['vehicle', 'model'])}
      />
    ].concat(isMobile ? mobileCells[vehicleType] : desktopCells[vehicleType])
})

export default SingleRow
